import styled from "styled-components";
import { theme } from "Globals/Styles/AppTheme";
import { Box, Button } from "@material-ui/core";

export const Page: any = styled(Box)`
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
    width: 100%;
    padding: 40px 35px;
`;

export const Row = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    width: 100%;
    padding: 8px 0;
    margin: 15px 30px 0px 0px;

    fieldset {
        margin-right: 30px;
    }

    > div {
        margin-right: 30px;
        &.MuiFormControl-root {
            margin-right: 30px;
        }
    }
    @media only screen and (max-width: 767px) {
        flex-direction: column;
        margin: 15px 0px;
        fieldset {
            margin-right: 0px;
            margin-bottom: 15px;
        }

        > div {
            margin-right: 0px;
            margin-bottom: 15px;
            &.MuiFormControl-root {
                margin-right: 0px;
                margin-bottom: 15px;
            }
        }
    }
`;
